<script>
  import { getContext, createEventDispatcher } from "svelte";
  import Icon, { DocumentDuplicate } from "svelte-hero-icons";
  import { headerDisplayStore } from '../../stores/General'
  import { onMount } from "svelte";
import CustomIcon from "../CustomIcon.svelte";
  export let type = "text";
  export let label;
  export let name;
  export let required = false;
  export let initialValue;
  export let value;
  export let isBidTemplate = true;

  const { onFormChange, onBlur } = getContext("form");
  const dispatch = createEventDispatcher();

  function callDispatcher(e) {
    dispatch("checkvalid", e);
  }
  onMount(() => {
    value = initialValue || "";
  });

  function Copy() {
    /* Get the text field */
    var copyText = document.getElementById(name);
    if (copyText !== null) {
      
    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */

    /* Copy the text inside the text field */
    navigator.clipboard.writeText(copyText.value);

    /* Alert the copied text */
    copyText.focus();
    copyText.select();
    headerDisplayStore.ShowNotification(
        {
          title: "Success",
          subtitle: "Successfully Copied To Clipboard"
        }
      );
    }
  }
</script>

<div class="w-full">
  <label
    for={name}
    class="justify-self-end block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2 w-full"
  >
    {label}
    {#if required}
      <span class="text-red-500">*</span>
    {/if}
  </label>
  <div
    class="flex relative mt-1 sm:col-span-2 w-full items-between   shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-field-border-gray rounded-md h-60 border-solid border-2"
  >
    {#if value != ""}
      <div class="flex w-full h-full  pr-40">
        <textarea
          id={name}
          style="resize: none;"
          {value}
          {type}
          {name}
          disabled
          on:blur={onBlur}
          on:input={callDispatcher}
          on:input={onBlur}
          class="flex flex-1 m-3 overflow-y-scroll overflow-x-hidden outline-none border-none"
        />
      </div>
    {:else}
      <div class="flex flex-col items-center justify-center w-full h-full">
        

        <CustomIcon width="157"
        height="130" name="request"/>

        <p class="mt-2">No available bid request</p>
      </div>
    {/if}

    {#if isBidTemplate}
      <button
        type="button"
        on:click={() => {
          Copy();
        }}
        class="mr-3 right-2 absolute mt-3 w-36 h-12  inline-flex items-center justify-center px-1 py-2 rounded-md !border-2 shadow-nv border-custom-copy-button text-sm font-medium  text-blue-400  focus:z-10  focus:ring-1 focus:ring-blue-600 focus:border-blue-600"
      >
        <Icon src={DocumentDuplicate} class="mr-2.5 h-5 w-5 text-blue" solid />
        <span>Copy</span>
      </button>
    {/if}
  </div>
</div>
